import Vue from 'vue';

Vue.component('vuetable-drawer-session', () =>
    import(/* webpackChunkName: 'drawer-session-index' */ './vuetable-drawer-session.vue'),
);
